// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__k+vy+"};